import axios from "axios";
import NProgress from "nprogress";
import Cookie from "js-cookie";
import router from "../router";
import { Message } from "element-ui";
import store from "../store";
import timApi from "../utils/timApi";
//  请求拦截
axios.interceptors.request.use(
  (config) => {
    NProgress.start();
    if (Cookie.get("token"));
    config.headers.common.Authorization = `Bearer ${Cookie.get("token")}`;
    config.headers.common["Accept-language"] = store.getters.language;

    // starNote学院相关接口自动添加 client-type header
    const url = config.url || "";
    const isStarNoteApi =
      url.includes("/api/v2/admin/boox/") ||
      url.includes("/api/v2/admin/material/") ||
      url.includes("/api/v2/admin/fileAsset/");

    if (isStarNoteApi) {
      // 在 headers 中设置 client-type（galaxy 的实现方式）
      config.headers.common["client-type"] = "boox";

      // 同时为了兼容，也在请求体中添加 client_type（如果请求体是对象且不存在该字段）
      const method = (config.method || "").toLowerCase();
      if ((method === "post" || method === "put") && config.data) {
        if (typeof config.data === "object" && !(config.data instanceof FormData)) {
          if (!config.data.client_type) {
            config.data.client_type = "boox";
          }
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//  响应拦截
axios.interceptors.response.use(
  (res) => {
    NProgress.done();
    return res.data;
  },
  (error) => {
    NProgress.done();
    if (error.response.status === 401) {
      timApi.logoutIM();
      Cookie.remove("token");
      store.commit("CLEAR_ROUTER");
      Message({
        type: "error",
        message: "账号登录已过期，请重新登录",
      });
      router.push({
        name: "login",
        query: {
          redirect: router.history.pending.fullPath,
        },
      });
    } else {
      Message({
        type: "error",
        message: error.response.data.message,
      });
    }
    return Promise.reject(error);
  }
)[("a", "b")];

export default {
  //  登录
  login: (params) => axios.post(`/api/1/users/login`, params),

  // 获取个人信息
  getUser: () => axios.get("/api/1/users/me"),

  //  获取用户
  getUsers: (params) =>
    axios.get(`/api/1/users`, {
      params: params,
    }),

  //  添加用户
  addUsers: (params) => axios.post("/api/1/users/signup", params),

  //  获取单个用户
  getSingleUsers: (id) => axios.get(`/api/1/users/${id}`),

  // 导出用户信息
  exportUserData: () => axios.get(`/api/1/users/admin/exportData`),

  // 获取阿里云参数
  aliyunSts: () => axios.get("/api/1/books/oss/sts"),

  // 获取阿里云buckets
  getOssBuckets: () => axios.get("/api/1/config/buckets"),

  // 获取galaxy OSS模块配置（动态获取bucket）
  getGalaxyOssModule: () => axios.get("/api/v2/admin/config/galaxyOssModule"),

  //  更新用户
  updateUsers: (id, params) => axios.put(`/api/1/users/${id}`, params),

  //  删除用户
  deleteUsers: (id) => axios.delete(`/api/1/users/${id}`),

  //  注销用户
  destroyUsers: (params) => axios.post(`/api/1/users/destroy/user`, params),

  //  token失效
  disableToken: (params) => axios.post(`/api/1/users/disable/token`, params),

  //  给用户发送数据清理邮件
  sendClearEmail: (params) =>
    axios.post(`/api/1/users/applyClearUserData`, params),

  //  修正存储用户大小
  calibration: (params) =>
    axios.get(`/api/1/users/admin/calibration/size`, {
      params,
    }),

  //  笔记PDF修正
  delRepeat: (params) =>
    axios.get(`/api/1/users/admin/pdf/delRepeat`, {
      params,
    }),

  //  查询用户OSS数据
  checkOssInfo: (params) => axios.post(`/api/1/users/ossFileList`, params),

  //  获取用户容量详情
  getUserOssStorage: (params) =>
    axios.get(`/api/1/statistics/admin/storage/detail`, { params }),

  //  查询用户OSS统计
  getOssStatistics: (params) =>
    axios.get(`/api/1/statistics/admin/storage`, { params }),

  // 验证fid唯一性
  verifyFid: (params) =>
    axios.get(`/api/1/orgs/verifyFid`, {
      params: params,
    }),

  // 获取机构列表
  getOrgList: (params) =>
    axios.get("/api/1/orgs", {
      params: params,
    }),

  // 获取机构详情
  getOrgDetail: (id) => axios.get(`/api/1/orgs/${id}`),

  // 创建机构
  createOrg: (params) => axios.post("/api/1/orgs", params),

  // 编辑机构
  editOrg: (id, params) => axios.put(`/api/1/orgs/${id}`, params),

  // 添加机构
  addOrgs: (params) => axios.get(`/api/1/orgs`, params),

  // 删除机构
  delOrg: (id) => axios.delete(`/api/1/orgs/${id}`),

  // 机构解绑设备
  unBindDevice: (params) => axios.post(`/api/1/orgs/unBindDevice`, params),

  // 获取机构下的设备列表
  getOrgDevices: (id, params) =>
    axios.get(`/api/1/orgs/${id}/getDevices`, {
      params: params,
    }),

  // 获取设备列表
  // getDevices: (orgID, params) => axios.get(`/api/1/devices/`, { params: params }),

  // 机构绑定设备
  bindDevice: (id, params) =>
    axios.post(`/api/1/orgs/bindDevice/${id}`, params),

  // 获取机构应用列表
  orgGetApp: (id, params) =>
    axios.get(`/api/1/apps/${id}/orgGetApp`, {
      params: params,
    }),

  // 机构绑定应用
  orgAddApp: (orgID, params) =>
    axios.post(`/api/1/apps/${orgID}/orgAddApp`, params),

  // 机构移除应用
  orgDelApp: (orgID, appID) =>
    axios.delete(`/api/1/apps/${orgID}/orgDelApp/${appID}`),

  // 超星应用排序
  orgSortApp: (orgID, params) =>
    axios.post(`/api/1/apps/${orgID}/orgSortApp`, params),

  //  获取角色
  getRoles: () => axios.get("/api/1/roles"),

  //  新增角色
  addRoles: (params) => axios.post(`/api/1/roles`, params),

  //  删除角色
  delRoles: (id) => axios.delete(`/api/1/roles/${id}`),

  // 获取机构标签列表
  getTagList: (params) =>
    axios.get("/api/1/tags", {
      params: params,
    }),

  // 获取标签详情
  getTagDetail: (id) => axios.get(`/api/1/tags/${id}`),

  // 添加标签
  addTag: (params) => axios.post("/api/1/tags", params),

  // 删除标签
  delTag: (id) => axios.delete(`/api/1/tags/${id}`),

  // 标签添加机构
  tagAddOrg: (id, params) => axios.post(`/api/1/tags/${id}/addOrg`, params),

  // 删除标签下的机构
  tagDelOrg: (tagID, orgID) =>
    axios.delete(`/api/1/tags/${tagID}/delOrg/${orgID}`),

  // 标签批量添加应用
  batchAddConf: (params) => axios.post(`/api/1/apps/batchAddConf`, params),

  // 编辑开关机屏保
  editScreen: (params) => axios.post(`/api/1/deviceAssets/upsert`, params),

  // 批量编辑开关屏保
  batchAddScreen: (params) =>
    axios.post(`/api/1/deviceAssets/upsertByTag`, params),

  //  忘记密码
  forgetPass: (params) => axios.post(`/api/1/users/forget`, params),

  //  重置密码
  resetPass: (params, token) =>
    axios.post(`/api/1/users/resetPass`, params, {
      headers: {
        Authorization: token,
      },
    }),

  //  获取超星应用
  getApp: (params) =>
    axios.get(`/api/1/apps`, {
      params: params,
    }),

  //  获取单个超星应用
  getSingleApp: (id) => axios.get(`/api/1/apps/${id}`),

  //  删除超星应用
  deleteApp: (id) => axios.delete(`/api/1/apps/${id}`),

  //  添加超星应用
  addApp: (params) => axios.post(`/api/1/apps`, params),

  //  编辑超星应用
  updateApp: (id, params) => axios.put(`/api/1/apps/${id}`, params),

  //  验证登录名
  verifyLoginName: (params) =>
    axios.get(`/api/1/users/verifyUsername`, {
      params: params,
    }),

  //  获取模块列表
  getModules: (params) =>
    axios.get(`/api/1/modules`, {
      params: params,
    }),

  //  更新角色的模块访问权限
  updateRoleModules: (params) =>
    axios.post(`/api/1/roleAccess/batchUpdate`, params),

  //  根据角色获取模块访问权限
  getRoleModules: (id, params) =>
    axios.get(`/api/1/roles/getModuleByRole/${id}`, {
      params: params,
    }),

  //  获取版本
  getVersion: (params) =>
    axios.get(`/api/1/firmwares`, {
      params: params,
    }),

  //  创建版本
  addVersion: (params) => axios.post(`/api/1/firmwares`, params),

  // 发布版本
  pushVersion: (params) => axios.post(`/api/1/firmwares/pulish`, params),

  // 获取书单频道
  getBookChannels: (params) =>
    axios.get(`/api/1/channels`, {
      params: params,
    }),

  // 创建书单
  createModules: (params) => axios.post(`/api/1/pc/modules`, params),
  // 创建频道
  createChannels: (params) => axios.post(`/api/1/channels`, params),
  // 频道书籍拖拽排序
  sortChannelsBook: (params) =>
    axios.post(`/api/1/pc/modules/updateOrdinal`, params),
  // 编辑书单信息
  editModules: (id, params) => axios.put(`/api/1/pc/modules/${id}`, params),
  // 更新书单信息
  refreshModules: (id, params) =>
    axios.get("/api/1/shop/modules/jd/syncJDModules", {
      params: params,
    }),

  // 编辑书籍信息
  editBooks: (id, params) => axios.put(`/api/1/categories/${id}`, params),

  // 批量设置书籍价格
  setBooksPrice: (params) => axios.put(`/api/1/books/price/edit`, params),

  // 删除频道/书单
  delChannels: (id) => axios.delete(`/api/1/pc/modules/${id}`),

  // 获取书单详情
  getModulesDetail: (id, params) =>
    axios.get(`/api/1/pc/modules/${id}`, {
      params: params,
    }),

  // 书单发布到频道
  listTochannel: (id, params) =>
    axios.post(`/api/1/pc/modules/public/${id}`, params),

  // 创建分类
  createCategories: (params) => axios.post(`/api/1/categories`, params),

  // 删除分类
  delCategories: (id) => axios.delete(`/api/1/categories/${id}`),

  // 获取书籍分类
  getBookCategories: () => axios.get(`/api/1/categories/getList`),

  // 添加书籍到分类
  categoriesAddBook: (id, params) =>
    axios.post(`/api/1/categories/addBook/${id}`, params),

  //  分类管理排序
  bookCategoriesOrder: (params) =>
    axios.post(`/api/1/categories/updateOrdinalById`, params),

  // 获取书籍分类详情
  getCategoriesDetail: (id, params) =>
    axios.get(`/api/1/categories/${id}`, {
      params: params,
    }),
  //获取设备
  getfacilitys: (params) =>
    axios.get(`/api/1/devices`, {
      params: params,
    }),
  addFacilitys: (params) => axios.post(`/api/1/users/add/device`, params),

  uploadFacilitys: (params) =>
    axios.post(`/api/1/users/add/device/batch`, params),

  // 解绑设备
  facilityUntie: (params) =>
    axios.post("/api/1/users/admin/unbind/device", params),

  // 批量解绑设备
  facilityBatchUntie: (params) =>
    axios.post("/api/1/users/admin/unbind/device/batch", params),

  // 锁定设备
  facilityLock: (params) => axios.post("/api/1/devices/admin/lock", params),

  // 重置设备锁屏密码
  resetMacPwd: (params) => axios.post("/api/1/users/resetPwd", params),

  // 书单添加书籍
  moduleAddBooks: (id, params) =>
    axios.post(`/api/1/pc/modules/addBook/${id}`, params),

  // 书单删除
  moduleDelBooks: (id, params) =>
    axios.post(`/api/1/pc/modules/removeBook/${id}`, params),

  // 书籍删除
  moduleOutBooks: (id, params) =>
    axios.post(`/api/1/categories/removeBooks/${id}`, params),

  // 书籍上/下架
  updateStackBooks: (params) => axios.put(`/api/1/books/status/update`, params),

  //  获取固件
  getFirmware: (params) =>
    axios.get(`/api/1/firmwares`, {
      params: params,
    }),

  // 添加固件
  addFirmware: (params) => axios.post(`/api/1/firmwares`, params),

  // 删除固件
  delFirmware: (id) => axios.delete(`/api/1/firmwares/${id}`),

  //  获取单个固件
  getSingleFirmware: (id) => axios.get(`/api/1/firmwares/${id}`),

  //  编辑固件
  editFirmware: (id, params) => axios.put(`/api/1/firmwares/${id}`, params),

  // 获取书籍详情
  getBookDetails: (id, params) =>
    axios.get(`/api/1/books/${id}`, {
      params: params,
    }),

  // 编辑书籍
  updateBook: (id, params) => axios.put(`/api/1/books/${id}`, params),

  //  频道&书单管理排序
  bookChannelOrder: (params) =>
    axios.post(`/api/1/pc/modules/updateOrdinalById`, params),

  //  书单管理排序
  bookListOrder: (params) =>
    axios.post(`/api/1/pc/modules/updateOrdinal`, params),

  //  书单管理排序
  bookOrder: (params) => axios.post(`/api/1/pc/modules/book/ordinal`, params),
  // 章节修改
  chaptersBooks: (params) => axios.post(`/api/1/chapters`, params),
  // 获取章节列表
  getChaptersBooks: (bookId) =>
    axios.get(`/api/1/chapters/book?bookId=${bookId}`),
  //    上传书
  uploadBooks: (params) => axios.post(`/api/1/books/upload`, params),
  //    删除书
  deleteBooks: (id) => axios.delete(`/api/1/chapters/${id}`),
  //    更新名称
  editChaptersBooks: (id, params) => axios.put(`/api/1/chapters/${id}`, params),

  // 获取优惠券列表
  getCoupons: (params) =>
    axios.get("/api/1/coupons", {
      params: params,
    }),

  // 创建优惠券
  createCoupons: (params) => axios.post("/api/1/coupons", params),

  // 编辑优惠券
  editCoupons: (id, params) => axios.put(`/api/1/coupons/${id}`, params),

  // 获取优惠券详情
  getCouponsDetails: (id) => axios.get(`/api/1/coupons/${id}`),

  // 删除优惠券
  deleteCoupons: (id) => axios.delete(`/api/1/coupons/${id}`),

  // 导出订单列表
  exportOrdersData: (params) => axios.post(`/api/1/orders/exportData`, params),
  // 获取订单列表
  getOrders: (params) =>
    axios.get(`/api/1/orders`, {
      params,
    }),
  // 获取订单详情
  getOrdersDetails: (id) => axios.get(`/api/1/orders/${id}`),

  // 获取广告列表
  getAds: (params) =>
    axios.get(`/api/1/ads`, {
      params,
    }),

  // 获取书单id列表
  getBookList: (params) =>
    axios.get(`/api/1/pc/modules`, {
      params,
    }),

  // 添加广告
  createAds: (params) => axios.post(`/api/1/ads`, params),

  // 获取广告详情
  getAdsDetails: (id) => axios.get(`/api/1/ads/${id}`),

  // 删除广告
  delAds: (id) => axios.delete(`/api/1/ads/${id}`),

  // 编辑广告
  editAds: (id, params) => axios.put(`/api/1/ads/${id}`, params),

  // 广告发布或取消
  publicAds: (id, params) => axios.put(`/api/1/ads/${id}/publicAd`, params),

  // 获取PC端统计数据
  pcStatsByDate: (params) =>
    axios.get(`/api/1/pcDownloads/verison/statistics`, {
      params,
    }),

  // 微信硬件绑定用户统计
  wechatIotByDate: (params) =>
    axios.get(`/api/1/wechatIot/statistics`, { params }),

  // 获取新增用户统计
  userByDate: (params) =>
    axios.get(`/api/1/statistics/userByDate`, {
      params,
    }),

  // 获取新增设备型号统计
  deviceByDate: (params) =>
    axios.get(`/api/1/statistics/deviceByDate`, {
      params,
    }),

  // 获取bucket容量统计
  storageByDate: (params) =>
    axios.get(`/api/1/statistics/usedStorage/storageByDate`, {
      params,
    }),

  // 获取型号分布统计列表
  modelStatistics: (params) =>
    axios.get(`/api/firmware/modelStatistics/`, {
      params,
    }),

  // 获取诗词分类
  getPoetriesClassify: (params) =>
    axios.get(`/api/1/poetries/type/list`, {
      params,
    }),

  // 获取诗词分类列表
  getPoetriesClassifyList: (params) =>
    axios.get(`/api/1/poetries`, {
      params,
    }),

  // 获取诗词个人频道
  getPoetriesChannel: (params) =>
    axios.get(`/api/1/poetries/category/list`, {
      params,
    }),

  // 获取诗词个人频道详情
  getPoetriesChannelList: (params) =>
    axios.get(`/api/1/poetries/category/show`, {
      params,
    }),

  // 导入诗词到个人频道
  addPoetry: (params) =>
    axios.post(`/api/1/poetries/category/addPoetry`, params),

  // 删除个人频道诗词
  delPoetryChannelList: (params) =>
    axios.post(`/api/1/poetries/category/delPoetry`, params),

  // 诗词创建个人频道
  createPoetryChannel: (params) =>
    axios.post(`/api/1/poetries/category/create`, params),

  // 诗词删除个人频道
  delPoetryChannel: (params) =>
    axios.delete(`/api/1/poetries/category/del`, {
      params,
    }),

  // 诗词编辑个人频道
  editPoetryChannel: (params) =>
    axios.put(`/api/1/poetries/category/put`, params),

  // 获取字典分类
  getDictionaryClassify: (params) =>
    axios.get(`/api/1/stardicts/type/list`, {
      params,
    }),

  // 获取字典个人频道
  getDictionaryChannel: (params) =>
    axios.get(`/api/1/stardicts/category/list`, {
      params,
    }),

  // 获取个人频道字典单词
  getDictionaryChannelList: (params) =>
    axios.get(`/api/1/stardicts/category/show`, {
      params,
    }),

  // 创建字典个人频道
  createDictionaryChannel: (params) =>
    axios.post(`/api/1/stardicts/category/create`, params),

  // 获取字典分类列表
  getDictionaryClassifyList: (params) =>
    axios.get(`/api/1/stardicts/search`, {
      params,
    }),

  // 单词添加到个人频道
  addDictionary: (params) =>
    axios.post(`/api/1/stardicts/category/addStardict`, params),

  // 字典编辑个人频道
  editDictionaryChannel: (params) =>
    axios.put(`/api/1/stardicts/category/put`, params),

  // 字典删除个人频道
  delDictionaryChannel: (params) =>
    axios.delete(`/api/1/stardicts/category/del`, {
      params,
    }),

  // 删除个人频道单词
  delDictionaryChannelList: (params) =>
    axios.post(`/api/1/stardicts/category/delStardict`, params),

  // ===============================================

  // 获取格言分类
  getMottoClassify: (params) =>
    axios.get(`/api/1/mottos/type/list`, {
      params,
    }),

  // 获取格言分类详情
  getMottoClassifyList: (params) =>
    axios.get(`/api/1/mottos`, {
      params,
    }),

  // 获取格言个人频道
  getMottoChannel: (params) =>
    axios.get(`/api/1/mottos/category/list`, {
      params,
    }),

  // 导入格言到个人频道
  addMotto: (params) => axios.post(`/api/1/mottos/category/addMotto`, params),

  // 获取格言个人频道详情
  getMottoChannelList: (params) =>
    axios.get(`/api/1/mottos/category/show`, {
      params,
    }),

  // 格言创建个人频道
  createMottoChannel: (params) =>
    axios.post(`/api/1/mottos/category/create`, params),

  // 格言编辑个人频道
  editMottoChannel: (params) => axios.put(`/api/1/mottos/category/put`, params),

  // 格言删除个人频道
  delMottoChannel: (params) =>
    axios.delete(`/api/1/mottos/category/del`, {
      params,
    }),

  // 删除个人频道格言
  delMottoChannelList: (params) =>
    axios.post(`/api/1/mottos/category/delMotto`, params),

  // ===============================================

  // 获取设备电量信息列表
  getPowerInfo: (params) =>
    axios.get(`/api/1/powerInfos`, {
      params,
    }),

  // 创建设备电量信息
  createPowerInfo: (params) => axios.post(`/api/1/powerInfos`, params),

  // 编辑设备电量信息
  updatePowerInfo: (id, params) => axios.put(`/api/1/powerInfos/${id}`, params),

  // 获取设备电量信息详情
  getPowerInfoDetails: (id) => axios.get(`/api/1/powerInfos/${id}`),

  // 删除设备电量信息
  delPowerInfo: (id) => axios.delete(`/api/1/powerInfos/${id}`),

  // 获取网页解析规则列表
  getUrlParseInfo: (params) =>
    axios.get(`/api/1/urlParses`, {
      params,
    }),

  // 创建网页解析规则
  createUrlParseInfo: (params) => axios.post(`/api/1/urlParses`, params),

  // 编辑网页解析规则
  updateUrlParseInfo: (id, params) =>
    axios.put(`/api/1/urlParses/${id}`, params),

  // 获取网页解析规则详情
  getUrlParseInfoDetails: (id) => axios.get(`/api/1/urlParses/${id}`),

  // 删除网页解析规则
  delUrlParseInfo: (id) => axios.delete(`/api/1/urlParses/${id}`),

  // 获取设备型号标签列表
  getModelGroups: (params) =>
    axios.get(`/api/1/modelGroups`, {
      params,
    }),

  // 创建设备型号标签
  createModelGroups: (params) => axios.post(`/api/1/modelGroups`, params),

  // 查看设备型号标签详情
  checkModelGroups: (id) => axios.get(`/api/1/modelGroups/${id}`),

  // 删除设备型号标签
  delModelGroups: (id) => axios.delete(`/api/1/modelGroups/${id}`),

  // 编辑设备型号标签
  updateModelGroups: (id, params) =>
    axios.put(`/api/1/modelGroups/${id}`, params),

  // 获取用户手册设备型号标签列表
  getManualGroups: (params) =>
    axios.get(`/api/1/manualGroups`, {
      params,
    }),

  // 创建用户手册设备型号标签
  createManualGroups: (params) => axios.post(`/api/1/manualGroups`, params),

  // 删除用户手册设备型号标签
  delManualGroups: (id) => axios.delete(`/api/1/manualGroups/${id}`),

  // 编辑用户手册设备型号标签
  updateManualGroups: (id, params) =>
    axios.put(`/api/1/manualGroups/${id}`, params),

  // 获取设备语言标签列表
  getLangGroups: (params) =>
    axios.get(`/api/1/langGroups`, {
      params,
    }),

  // 创建设备语言标签
  createLangGroups: (params) => axios.post(`/api/1/langGroups`, params),

  // 删除设备语言标签
  delLangGroups: (id) => axios.delete(`/api/1/langGroups/${id}`),

  // 编辑设备语言标签
  updateLangGroups: (id, params) =>
    axios.put(`/api/1/langGroups/${id}`, params),

  // 未统计标签
  getNoStatistical: (params) => axios.post(`/api/1/im/tag/state`, params),

  // 获取当前标签详情
  getFeedbackTagDetails: (params) => axios.post(`/api/1/im/tag/detail`, params),

  // 获取屏保
  getScreenSavers: (params) =>
    axios.get(`/api/1/screenSavers/page/list`, {
      params,
    }),

  // 创建屏保
  createScreenSavers: (params) => axios.post(`/api/1/screenSavers`, params),

  // 编辑屏保
  editScreenSavers: (id, params) =>
    axios.put(`/api/1/screenSavers/${id}`, params),

  // 删除屏保
  delScreenSavers: (id) => axios.delete(`/api/1/screenSavers/${id}`),

  // 获取屏保详情
  getScreenSaversDetails: (id) => axios.get(`/api/1/screenSavers/${id}`),

  // 屏保图片上传
  uploadScreenImg: (params) =>
    axios.post(`/api/1/screenSavers/uploadImg`, params),

  // 获取笔记背景图
  getWriteTemplates: (params) =>
    axios.get(`/api/1/writeTemplates/page/list`, {
      params,
    }),

  // 创建笔记背景图
  createWriteTemplates: (params) => axios.post(`/api/1/writeTemplates`, params),

  // 编辑笔记背景图
  editWriteTemplates: (id, params) =>
    axios.put(`/api/1/writeTemplates/${id}`, params),

  // 删除笔记背景图
  delWriteTemplates: (id) => axios.delete(`/api/1/writeTemplates/${id}`),

  // 获取笔记背景图详情
  getWriteTemplatesDetails: (id) => axios.get(`/api/1/writeTemplates/${id}`),

  // 笔记背景图片上传
  uploadWriteTemplate: (params) =>
    axios.post(`/api/1/writeTemplates/uploadImg`, params),

  // 获取预装书列表
  getStaticBook: (params) =>
    axios.get(`/api/1/staticBooks`, {
      params,
    }),

  // 创建预装书
  createStaticBook: (params) => axios.post(`/api/1/staticBooks`, params),

  // 编辑预装书
  updateStaticBook: (id, params) =>
    axios.put(`/api/1/staticBooks/${id}`, params),

  // 获取预装书详情
  getStaticBookDetails: (id) => axios.get(`/api/1/staticBooks/${id}`),

  // 删除预装书
  delStaticBook: (id) => axios.delete(`/api/1/staticBooks/${id}`),

  // 获取IM用户签名
  getSig: (params) =>
    axios.get("/api/1/im/getSig", {
      params,
    }),

  // 信息反馈查询
  feedbackSearch: (params) =>
    axios.get("/api/1/im/feedbackSearch", {
      params,
    }),

  // 获取信息反馈会话列表
  feedbackList: (params) =>
    axios.get("/api/1/im/feedbackList", {
      params,
    }),

  // 更新信息反馈用户备注
  updatefeedbackRemark: (params) => axios.post("/api/1/im/remark/add", params),

  // 信息反馈添加cb用户备注
  addCbFeedbackRemark: (params) => axios.post("/api/1/cb/remark/add", params),
  // 获取cb用户备注列表
  getCbFeedbackRemark: (params) =>
    axios.get("/api/1/cb/remark/list", { params }),

  // 过滤信息反馈会话列表
  filiterFeedbackList: (params) => axios.post("/api/1/im/feedbackList", params),

  // 信息撤回
  revokeMessage: (params) => axios.post("/api/1/im/recall/msg/device", params),

  // 信息已读
  readMessage: (params) => axios.post("/api/1/cb/setFeedbackRead", params),
  // 信息撤回
  revokeCbMessage: (params) =>
    axios.post("/api/1/cb/setFeedbackRevoke", params),

  // 创建机器人消息
  createBotMsg: (params) => axios.post("/api/1/im/botMsg", params),

  // 删除机器人消息
  delBotMsg: (id) => axios.delete(`/api/1/im/botMsg/${id}`),

  // 更新机器人消息
  updateBotMsg: (id, params) => axios.put(`/api/1/im/botMsg/${id}`, params),

  // 获取机器人消息列表
  getBotMsg: (params) =>
    axios.get(`/api/1/im/botMsg`, {
      params,
    }),

  // 创建boox助手广告轮播
  appAd: (params) => axios.post(`/api/1/appAds`, params),

  // 获取boox助手广告
  getAppAd: (params) =>
    axios.get(`/api/1/appAds/show/one`, {
      params,
    }),

  // 更新boox助手广告
  updateAppAd: (id, params) => axios.put(`/api/1/appAds/${id}`, params),

  // 删除boox助手广告
  delAppAd: (id) => axios.delete(`/api/1/appAds/${id}`),

  // 创建礼品卡
  createGift: (params) => axios.post(`/api/1/giftCards`, params),

  // 删除礼品卡
  delGift: (id) => axios.delete(`/api/1/giftCards/${id}`),

  // 更新礼品卡
  updateGift: (id, params) => axios.put(`/api/1/giftCards/${id}`, params),

  // 获取礼品卡列表
  getGift: (params) =>
    axios.get(`/api/1/giftCards`, {
      params,
    }),

  // 获取礼品卡详情
  getGiftDetails: (id) => axios.get(`/api/1/giftCards/${id}`),

  // 获取礼品卡详情列表
  getGiftCode: (params) =>
    axios.get(`/api/1/giftCards/code/list`, {
      params,
    }),

  // 获取礼品操作历史
  getGiftOpeHistory: (params) =>
    axios.get(`/api/1/opeHistory`, {
      params,
    }),

  // 删除礼品卡Item
  delGiftCode: (id) => axios.delete(`/api/1/giftCards/code/${id}`),

  // 更新礼品卡Code
  updateGiftCode: (id, params) =>
    axios.put(`/api/1/giftCards/code/${id}`, params),

  // 创建礼品卡Code
  createGiftCode: (params) => axios.post(`/api/1/giftCards/code/add`, params),

  // 回收礼品卡
  recoveryGiftCode: (params) =>
    axios.put(`/api/1/giftCards/recall/code/`, params),

  // 上传apk获取短链接
  getShortUrl: (params) => axios.post(`/api/1/url`, params),

  // 创建booxApp
  createBooxApp: (params) => axios.post(`/api/1/appAssistants`, params),

  // 删除booxApp
  delBooxApp: (id) => axios.delete(`/api/1/appAssistants/${id}`),

  // 更新booxApp
  updateBooxApp: (id, params) =>
    axios.put(`/api/1/appAssistants/${id}`, params),

  // 获取booxApp列表
  getBooxApp: (params) =>
    axios.get(`/api/1/appAssistants/page/list`, {
      params,
    }),

  // 获取booxApp详情
  getBooxAppDetails: (id) => axios.get(`/api/1/appAssistants/${id}`),

  // 创建浏览器扩展/用户手册
  createCloudFiles: (params) => axios.post(`/api/1/cloudFiles`, params),

  // 删除浏览器扩展/用户手册
  delCloudFiles: (id) => axios.delete(`/api/1/cloudFiles/${id}`),

  // 更新浏览器扩展/用户手册
  updateCloudFiles: (id, params) =>
    axios.put(`/api/1/cloudFiles/${id}`, params),

  // 获取浏览器扩展/用户手册列表
  getCloudFiles: (params) =>
    axios.get(`/api/1/cloudFiles`, {
      params,
    }),

  // 获取浏览器扩展/用户手册详情
  getCloudFilesDetails: (id) => axios.get(`/api/1/cloudFiles/${id}`),

  // 添加用户手册
  createManualFile: (params) =>
    axios.post(`/api/1/cloudFiles/file/adds`, params),
  // 更换用户手册文件
  replaceManualFile: (params) =>
    axios.put(`/api/1/cloudFiles/replace/file`, params),
  // 更新用户手册
  updateManualFile: (params) =>
    axios.put(`/api/1/cloudFiles/file/editModels`, params),

  // 用户手册查找关联型号
  getManualFileDetails: (params) =>
    axios.post(`/api/1/cloudFiles/file/models`, params),

  // ====================

  // 创建booxVersions
  createBooxVersions: (params) => axios.post(`/api/1/appVersions`, params),

  // 删除booxVersions
  delBooxVersions: (id) => axios.delete(`/api/1/appVersions/${id}`),

  // 更新booxVersions
  updateBooxVersions: (id, params) =>
    axios.put(`/api/1/appVersions/${id}`, params),

  // 获取booxVersions列表
  getBooxVersions: (params) =>
    axios.get(`/api/1/appVersions`, {
      params,
    }),

  // 获取booxVersions详情
  getBooxVersionsDetails: (id) => axios.get(`/api/1/appVersions/${id}`),

  // 获取笔记活跃用户数
  getNotesUseCount: (params) =>
    axios.get(`/api/1/statistics/doc/useCount`, {
      params,
    }),

  // 获取笔记，备份，推送数量
  getNotesUseDailyCount: (params) =>
    axios.get(`/api/1/statistics/cloud/dailyCount`, {
      params,
    }),

  // 获取笔记，备份，推送容量
  getNotesDailySize: (params) =>
    axios.get(`/api/1/statistics/cloud/dailySize`, {
      params,
    }),

  // 笔记用户新增数量
  getNotesUserAdd: (params) =>
    axios.get(`/api/1/statistics/doc/userAdd`, {
      params,
    }),

  // 笔记，推送，备份容量总占比
  getStorageCount: () => axios.get(`/api/1/statistics/doc/storageCount`),

  // 笔记，推送，备份数量总占比
  getSumCount: () => axios.get(`/api/1/statistics/doc/sumCount`),

  // 用户总量分布计算
  getUserAllCount: () => axios.get(`/api/1/statistics/cloud/userAllCount`),

  // 云盘平均数据
  getCloudAvg: () => axios.get(`/api/1/statistics/cloud/cloudAvg`),

  // 创建更新记录
  createUpdate: (params) => axios.post(`/api/1/updateLogs`, params),

  // 发布更新记录
  publicUpdate: (params) =>
    axios.post(`/api/1/updateLogs/publish/${params.id}`, params.data),

  // 获取更新记录列表
  getUpdateList: (params) =>
    axios.get(`/api/1/updateLogs`, {
      params,
    }),

  // 获取更新记录详情
  getUpdateDetails: (id) => axios.get(`/api/1/updateLogs/${id}`),

  // 更新记录详情
  putUpdate: (id, params) => axios.put(`/api/1/updateLogs/${id}`, params),

  // 删除更新记录
  delUpdate: (id) => axios.delete(`/api/1/updateLogs/${id}`),

  // 创建FAQ分类
  createFaqCategory: (params) => axios.post(`/api/1/faqs/category/add`, params),

  // 获取FAQ分类列表
  getFaqCategory: (params) =>
    axios.get(`/api/1/faqs/category/index`, {
      params,
    }),

  // 删除FAQ分类
  delFaqCategory: (params) =>
    axios.delete(`/api/1/faqs/category/del`, {
      params,
    }),

  // 更新FAQ分类
  updateFaqCategory: (params) => axios.put(`/api/1/faqs/category/edit`, params),

  // 创建FAQ
  createFaq: (params) => axios.post(`/api/1/faqs`, params),

  // 发布FAQ
  publicFaq: (params) =>
    axios.post(`/api/1/faqs/publish/${params.id}`, params.data),

  // 获取FAQ列表
  getFaqList: (params) =>
    axios.get(`/api/1/faqs`, {
      params,
    }),

  // 获取FAQ详情
  getFaqDetails: (id) => axios.get(`/api/1/faqs/${id}`),

  // FAQ详情
  putFaq: (id, params) => axios.put(`/api/1/faqs/${id}`, params),

  // 删除FAQ
  delFaq: (id) => axios.delete(`/api/1/faqs/${id}`),

  // 删除apk记录
  delApk: (id) => axios.delete(`/api/1/appAssistants/${id}`),

  // 获取更新记录列表
  getServerInfos: (params) =>
    axios.get(`/api/1/serverInfos/list`, {
      params,
    }),

  // 创建更新记录
  createServer: (params) => axios.post(`/api/1/serverInfos`, params),

  // 获取服务器详情
  getServerDetails: (id) => axios.get(`/api/1/serverInfos/${id}`),

  // 更新服务器
  putServer: (id, params) => axios.put(`/api/1/serverInfos/${id}`, params),

  // 删除更新记录
  delServer: (id) => axios.delete(`/api/1/serverInfos/${id}`),

  // 获取booxPC版本列表
  getPcVersions: (params) => axios.get(`/api/1/pcVersions`, { params }),
  // 创建booxPC版本
  createPcVersion: (params) => axios.post(`/api/1/pcVersions`, params),
  // 更新booxPC版本
  updatePcVersion: (id, params) => axios.put(`/api/1/pcVersions/${id}`, params),
  // 删除booxPC版本
  delPcVersion: (id) => axios.delete(`/api/1/pcVersions/${id}`),
  // 获取booxPC版本详情
  getPcVersionDetails: (id) => axios.get(`/api/1/pcVersions/${id}`),

  // 获取站点列表
  getThirdsite: (params) =>
    axios.get(`/api/1/thirdsite`, {
      params,
    }),

  // 创建站点
  createThirdsite: (params) => axios.post(`/api/1/thirdsite`, params),

  // 更新站点
  updateThirdsite: (id, params) => axios.put(`/api/1/thirdsite/${id}`, params),

  // 获取站点详情
  getThirdsiteDetails: (id) => axios.get(`/api/1/thirdsite/${id}`),

  // 删除站点
  delThirdsite: (id) => axios.delete(`/api/1/thirdsite/${id}`),

  // 获取用户反馈对话消息
  getFeedbackDialog: (params) =>
    axios.get(`/api/1/im/getFeedbackDialog`, {
      params: params,
    }),

  // 一键同步黑名单数据
  syncBlacklists: (params) =>
    axios.post(`/api/1/blacklists/sync/cn/data`, params),

  // 获取黑名单列表
  getBlacklists: (params) =>
    axios.get(`/api/1/blacklists`, {
      params: params,
    }),

  // 移出黑名单
  delBlacklists: (params) => axios.post(`/api/1/blacklists/del/bat`, params),

  // 添加黑名单
  addBlacklists: (params) => axios.post(`/api/1/blacklists`, params),

  // 获取型号黑名单列表
  getModelBlacklist: (params) => axios.get(`/api/1/blackModels`, { params }),

  // 添加型号黑名单
  addModelBlacklist: (params) => axios.post(`/api/1/blackModels`, params),

  // 编辑型号黑名单
  editModelBlacklist: (id, params) =>
    axios.put(`/api/1/blackModels/${id}`, params),

  // 批量删除型号黑名单
  batDelModelBlacklist: (params) =>
    axios.post(`/api/1/blackModels/del/bat`, params),

  // 删除单个型号黑名单
  delModelBlacklist: (id) => axios.delete(`api/1/blackModels/${id}`),

  // 信息反馈获取附件压缩包密码
  getFeedbackPsw: (id, params) =>
    axios.get(`/api/1/encrypt/${id}/getKeyByServer`, {
      params: params,
    }),

  // 获取feedbackTagCategory列表
  getFeedbackTagCategory: (params) =>
    axios.get(`/api/1/feedbackTagCategory`, { params }),

  // 创建feedbackTagCategory
  createFeedbackTagCategory: (params) =>
    axios.post(`/api/1/feedbackTagCategory`, params),

  // 更新feedbackTagCategory
  updateFeedbackTagCategory: (id, params) =>
    axios.put(`/api/1/feedbackTagCategory/${id}`, params),

  // 获取反馈标签
  getFeedbackTags: (params) => axios.get(`/api/1/feedbackTags`, { params }),

  // 获取反馈标签树结构
  getFeedbackTagsTree: (params) =>
    axios.get(`/api/1/feedbackTags/list/tree`, { params }),

  // 创建反馈标签
  addFeedbackTags: (params) => axios.post(`/api/1/feedbackTags`, params),

  // 删除反馈标签
  delFeedbackTags: (id, params) =>
    axios.delete(`/api/1/feedbackTags/${id}`, params),

  // 编辑反馈标签
  updateFeedbackTags: (id, params) =>
    axios.put(`/api/1/feedbackTags/${id}`, params),

  // 为反馈信息打标签
  addTagsToFeedback: (params) => axios.post(`/api/1/im/add/tags`, params),

  // 获取反馈信息标签统计列表
  getFeedbackTagCount: (params) => axios.post(`/api/1/im/tagCount`, params),

  // cb信息反馈打标签
  setFeedbackTagsToCB: (params) =>
    axios.post(`/api/1/cb/setFeedbackTags`, params),
  // cb信息反馈标签
  getFeedbackTagsToCB: (params) =>
    axios.post(`/api/1/cb/feedback/tags`, params),

  // 导出反馈已打标签
  exportFeedbackTag: (params) => axios.post(`/api/1/im/tag/export`, params),

  // 导出反馈未打标签
  exportFeedbackUnTag: (params) => axios.post(`/api/1/im/untag/export`, params),

  // 获取反馈未打标签列表
  getFeedbackUnTagList: (params) => axios.post(`/api/1/im/untag/list`, params),

  // 获取卡包列表
  getCards: (params) =>
    axios.get(`/api/1/giftCards/cardHolder/list`, {
      params: params,
    }),

  // 添加卡包
  addCard: (params) => axios.post(`/api/1/giftCards/cardHolder/add`, params),

  // 获取卡包详情
  getCardDetails: (params) =>
    axios.get(`/api/1/giftCards/cardHolder/detail`, {
      params,
    }),

  // 编辑卡包
  editCard: (id, params) =>
    axios.put(`/api/1/giftCards/cardHolder/update/${id}`, params),

  // 获取卡包可用列表
  getUseList: () => axios.get(`/api/1/giftCards/cardHolder/useList`),

  // 删除卡包
  delCard: (params) => axios.post(`/api/1/giftCards/cardHolder/del`, params),

  // 获取单词字典分类列表
  getPoetrys: (params) =>
    axios.get(`/api/1/poetries`, {
      params: params,
    }),

  // 添加诗词分类
  addPoetrys: (params) => axios.post(`/api/1/poetries`, params),

  // 获取诗词分类详情
  getPoetryDetail: (params) => axios.get(`/api/1/poetries/${params.id}`),

  // 修改分类信息
  editPoetry: (params) => axios.put(`/api/1/poetries/${params.id}`, params),

  // 判断分类标题是否存在
  existTitle: (params) =>
    axios.get("/api/1/poetries/existTitle", {
      params,
    }),

  // 删除诗词
  delPoetry: (id) => axios.delete(`/api/1/poetries/${id}`),

  // 获取诗词分类详情列表
  getPoetryDetails: (params) =>
    axios.get(`/api/1/poetries/item/list`, {
      params,
    }),

  // 获取诗词分类详情单个详情
  getPoetryItemDetail: (params) =>
    axios.get(`/api/1/poetries/item/show`, {
      params,
    }),

  // 添加诗词
  addPoetryItem: (params) => axios.post(`/api/1/poetries/item/create`, params),

  // 修改诗词信息
  editPoetryItem: (params) => axios.put(`/api/1/poetries/item/update`, params),

  // 删除诗词详情单个
  delPoetryItem: (params) =>
    axios.delete("/api/1/poetries/item/delete", {
      params,
    }),

  // 获取单词分类列表--------------------------------
  getStardicts: (params) =>
    axios.get(`/api/1/stardicts`, {
      params: params,
    }),

  // 添加单词分类
  addStardicts: (params) => axios.post(`/api/1/stardicts`, params),

  // 获取单词分类详情
  getStardictDetail: (params) => axios.get(`/api/1/stardicts/${params.id}`),

  // 修改单词分类信息
  editStardict: (params) => axios.put(`/api/1/stardicts/${params.id}`, params),

  // 判断单词分类标题是否存在
  stardictseEistTitle: (params) =>
    axios.get("/api/1/stardicts/existTitle", {
      params,
    }),

  // 删除单词分类单个
  delStardict: (id) => axios.delete(`/api/1/stardicts/${id}`),

  // 获取单词分类详情列表
  getStardictDetails: (params) =>
    axios.get(`/api/1/stardicts/item/list`, {
      params,
    }),

  // 获取单词分类详情单个详情
  getStardictItemDetail: (params) =>
    axios.get(`/api/1/stardicts/item/show`, {
      params,
    }),

  // 添加单词详情单个
  addStardictItem: (params) =>
    axios.post(`/api/1/stardicts/item/create`, params),

  // 修改单词信息
  editStardictItem: (params) =>
    axios.put(`/api/1/stardicts/item/update`, params),

  // 判断单词分类标题是否存在
  stardictseEistWord: (params) =>
    axios.get("/api/1/stardicts/item/existWord", {
      params,
    }),

  // 删除单词详情单个
  delStardictItem: (params) =>
    axios.delete("/api/1/stardicts/item/delete", {
      params,
    }),

  // 获取格言分类列表--------------------------------
  getMottos: (params) =>
    axios.get(`/api/1/mottos`, {
      params: params,
    }),

  // 添加格言分类
  addMottos: (params) => axios.post(`/api/1/mottos`, params),

  // 获取格言分类详情
  getMottoDetail: (params) => axios.get(`/api/1/mottos/${params.id}`),

  // 修改格言分类信息
  editMotto: (params) => axios.put(`/api/1/mottos/${params.id}`, params),

  // 判断格言分类标题是否存在
  mottoEistTitle: (params) =>
    axios.get("/api/1/mottos/existTitle", {
      params,
    }),

  // 删除格言分类单个
  delMotto: (id) => axios.delete(`/api/1/mottos/${id}`),

  // 获取格言分类详情列表
  getMottoDetails: (params) =>
    axios.get(`/api/1/mottos/item/list`, {
      params,
    }),

  // 获取格言分类详情单个详情
  getMottoItemDetail: (params) =>
    axios.get(`/api/1/mottos/item/show`, {
      params,
    }),

  // 添加格言详情单个
  addMottoItem: (params) => axios.post(`/api/1/mottos/item/create`, params),

  // 修改格言信息
  editMottoItem: (params) => axios.put(`/api/1/mottos/item/update`, params),

  // 删除格言详情单个
  delMottoItem: (params) =>
    axios.delete("/api/1/mottos/item/delete", {
      params,
    }),

  // 获取用户角色列表
  getPowerRolesList: (params) =>
    axios.get("/api/1/powerRoles", {
      params,
    }),

  // ===== 素材中心 PushConfig / NavConfig 依赖（对齐 galaxy）=====
  // 渠道列表
  getChannels: (params) => axios.get("/api/v2/admin/device/channel", { params }),

  // 推送配置 - 用户角色（galaxy 使用该接口）
  getPowerRole: () => axios.get("/api/v2/admin/boox/collegePowerRoles"),

  // App 版本列表（galaxy 返回 results，这里兼容转成 items）
  getVersions: async (params) => {
    const res = await axios.get("/api/v2/admin/appVersions", { params });
    try {
      if (res && res.data && res.data.results && !res.data.items) {
        res.data.items = res.data.results;
      }
    } catch (e) { }
    return res;
  },

  // 原生页面列表
  getNativePages: (params) =>
    axios.get("/api/v2/admin/messages/internalPage", { params }),

  // ===== 文件资产（对齐 galaxy fileUpload.ts）=====
  batchCreateFiles: (params) =>
    axios.post("/api/v2/admin/fileAsset/bulk", params),
  getFileConfigById: (ids) =>
    axios.post("/api/v2/admin/fileAsset/query", { ids }),

  // 创建用户角色
  addPowerRoles: (params) => axios.post("/api/1/powerRoles", params),

  // 更新用户角色
  editPowerRoles: (id, params) => axios.put(`/api/1/powerRoles/${id}`, params),

  // 删除用户角色
  delPowerRoles: (id) => axios.delete(`/api/1/powerRoles/${id}`),

  // 获取用户可选权限列表
  getPowersList: (params) =>
    axios.get("/api/1/powers", {
      params,
    }),

  // 创建可选权限
  createPowers: (params) => axios.post("/api/1/powers", params),

  // 编辑可选权限
  editPowers: (id, params) => axios.put(`/api/1/powers/${id}`, params),

  // 删除可选权限
  delPowers: (id) => axios.delete(`/api/1/powers/${id}`),

  // 获取权限使用情况列表
  usePowersList: (params) =>
    axios.get(`/api/1/userPowers`, {
      params,
    }),

  // 获取常用语分类列表
  getIdiomsClassify: (params) =>
    axios.get("/api/1/idiomCategorys/list/tree", { params }),

  // 创建常用语分类
  addIdiomsClassify: (params) => axios.post("/api/1/idiomCategorys", params),

  // 编辑常用语分类
  updateIdiomsClassify: (id, params) =>
    axios.put(`/api/1/idiomCategorys/${id}`, params),

  // 删除常用语分类
  delIdiomsClassify: (id) => axios.delete(`/api/1/idiomCategorys/${id}`),

  // 获取常用语列表
  getIdiomsList: (params) =>
    axios.get("/api/1/idioms", {
      params,
    }),

  // 创建常用语
  createIdioms: (params) => axios.post("/api/1/idioms", params),

  // 编辑常用语
  editIdioms: (id, params) => axios.put(`/api/1/idioms/${id}`, params),

  // 删除常用语
  delIdioms: (id) => axios.delete(`/api/1/idioms/${id}`),

  // couchbase统计
  getCouchbase: (params) =>
    axios.get(`/api/1/couchbase/storage/statistics`, {
      params,
    }),

  // 书库相关统计
  getLibraryStats: (params) =>
    axios.get(`/api/1/statistics/ossByDay`, {
      params,
    }),

  // oss数据相关统计
  getOssStatsData: (params) =>
    axios.get(`/api/1/oss/storage/statistics`, {
      params,
    }),

  // 权限相关统计
  getPermissionStat: (params) =>
    axios.get(`/api/statistics/userPowerRecord/time`, {
      params,
    }),

  // chatgpt相关统计
  getChatGptStat: (params) =>
    axios.post(`/api/1/statistics/chatgptRecord/time`, params),

  // chatgpt面板数据
  getChatGptYear: (params) =>
    axios.get(`/api/1/statistics/chatgptYear`, { params }),

  // oss用量面板数据
  getOssOverView: (params) =>
    axios.get(`/api/1/statistics/oss/overview`, { params }),

  // 京东流量统计
  getJDdeviceRecord: (params) =>
    axios.get(`/api/1/devicerecord/statistics`, { params }),

  // 京东购买金额统计
  getStatisticsAmountByDate: (params) =>
    axios.get(`/api/1/jdorders/statisticsAmountByDate`, { params }),

  // 京东购买人数统计
  getStatisticsUserByDate: (params) =>
    axios.get(`/api/1/jdorders/statisticsUserByDate`, { params }),

  // ocr,翻译，语音用量面板
  getAiYear: (params) => axios.get(`/api/1/statistics/aiYear `, { params }),

  // 创建设备型号
  createDevicesModel: (params) => axios.post(`/api/1/repos`, params),

  // 获取设备型号列表
  getDevicesModelList: (params) =>
    axios.get(`/api/1/repos`, {
      params,
    }),

  // 更新设备型号
  updateDevicesModel: (id, params) => axios.put(`/api/1/repos/${id}`, params),

  // 删除设备型号
  delDevicesModel: (id) => axios.delete(`/api/1/repos/${id}`),

  // 获取同步token
  getSyncToken: (params) =>
    axios.get(`/api/1/users/admin/syncToken`, {
      params,
    }),

  updateSyncChannels: (params) =>
    axios.post("/api/1/users/admin/updateSyncChannels", params),

  getLogsCategory: (params) =>
    axios.get(`/api/1/updateLogs/list/category`, {
      params,
    }),

  addLogsCategory: (params) =>
    axios.post(`/api/1/updateLogs/create/category`, params),

  updateLogsCategory: (params) =>
    axios.put(`/api/1/updateLogs/edit/category`, params),

  delLogsCategory: (params) =>
    axios.delete(`/api/1/updateLogs/del/category`, { params }),

  // 获取系统通知列表
  getSysNotice: (params) => axios.get(`/api/1/sysNotices`, { params }),

  // 获取系统通知详情
  getSysNoticeDetails: (id) => axios.get(`/api/1/sysNotices/${id}`),

  // 创建系统通知
  createSysNotice: (params) => axios.post(`/api/1/sysNotices`, params),

  // 删除系统通知
  delSysNotice: (id) => axios.delete(`/api/1/sysNotices/${id}`),

  // 更新系统通知
  updateSysNotice: (id, params) => axios.put(`/api/1/sysNotices/${id}`, params),

  // 获取设备绑定记录
  getbindingRecord: (params) =>
    axios.post(`/api/1/devices/bind/record`, params),

  // 获取设备操作历史
  getDevicesHistory: (params) =>
    axios.get(`/api/1/devices/action/history`, { params }),

  // 获取设备登录操作记录
  getDevicesLogin: (params) =>
    axios.get(`/api/1/devices/status/history`, { params }),

  // 撤回设备操作
  recallDevices: (params) =>
    axios.get(`/api/1/devices/action/recall`, { params }),

  // 获取登录广告列表
  getLoginAds: (params) => axios.get(`/api/1/loginAds`, { params }),
  // 创建登录广告
  createLoginAds: (params) => axios.post(`/api/1/loginAds`, params),
  // 删除登录广告
  delLoginAds: (id) => axios.delete(`/api/1/loginAds/${id}`),
  // 更新登录广告
  updateLoginAds: (id, params) => axios.put(`/api/1/loginAds/${id}`, params),
  // 更新登录广告详情
  getLoginAdsDetails: (id) => axios.get(`/api/1/loginAds/${id}`),

  // 获取RSS分类列表
  getRssCategory: (params) =>
    axios.get(`/api/1/rsses/category/list`, { params }),

  // 创建RSS分类
  createRssCategory: (params) =>
    axios.post(`/api/1/rsses/category/create`, params),

  // 删除RSS分类
  delRssCategory: (params) =>
    axios.delete(`/api/1/rsses/category/del`, { params }),

  // 更新RSS分类
  updateRssCategory: (params) =>
    axios.put(`/api/1/rsses/category/edit`, params),

  // 获取RSS详情列表
  getRssList: (params) => axios.get(`/api/1/rsses`, { params }),

  // 获取RSS列表详情
  getRssListDetails: (id) => axios.get(`/api/1/rsses/${id}`),

  // 创建RSS列表
  createRssList: (params) => axios.post(`/api/1/rsses`, params),

  // 导入OPML
  opmlImport: (params) => axios.post(`/api/1/rsses/public/import`, params),

  // 导出OPML
  opmlExport: (params) => axios.post(`/api/1/rsses/public/export`, params),

  // 删除RSS列表
  delRssList: (id) => axios.delete(`/api/1/rsses/${id}`),

  // 更新RSS列表
  updateRssList: (id, params) => axios.put(`/api/1/rsses/${id}`, params),

  // 获取微信硬件产品号列表
  getIotProducts: (params) => axios.get(`/api/1/iotProducts`, { params }),

  // 删除微信硬件产品
  delIotProducts: (id) => axios.delete(`/api/1/iotProducts/${id}`),

  // 更新微信硬件产品
  updateIotProducts: (id, params) =>
    axios.put(`/api/1/iotProducts/${id}`, params),

  // 新增微信硬件产品
  createIotProducts: (params) => axios.post(`/api/1/iotProducts`, params),

  // 获取微信硬件产品详情
  getIotProductsDetails: (id) => axios.get(`/api/1/iotProducts/${id}`),

  // 获取ddos预警配置列表
  getDDosConfigList: (params) =>
    axios.get(`/api/1/ddosWarningConfig`, { params }),

  // 获取ddos预警配置详情
  getDDosConfigDetails: (id) => axios.get(`/api/1/ddosWarningConfig/${id}`),

  // 新增ddos预警配置
  addDDosConfig: (params) => axios.post(`/api/1/ddosWarningConfig`, params),

  // 删除ddos预警配置
  delDDosConfig: (id) => axios.delete(`/api/1/ddosWarningConfig/${id}`),

  // 更新ddos预警配置
  updateDDosConfig: (id, params) =>
    axios.put(`/api/1/ddosWarningConfig/${id}`, params),

  // 获取系统配置详情
  getSysSettingsDetails: (id) => axios.get(`/api/1/sysSettings/one`),

  // 创建/更新系统配置详情
  updateSysSettingsDetails: (params) =>
    axios.post(`/api/1/sysSettings`, params),

  // 获取接口请求屏蔽列表
  getAccessBlackList: (params) =>
    axios.get(`/api/1/apiAccessBlacklist`, { params }),

  // 获取接口请求屏蔽详情
  getAccessBlackDetails: (id) => axios.get(`/api/1/apiAccessBlacklist/${id}`),

  // 新增接口请求屏蔽
  addAccessBlack: (params) => axios.post(`/api/1/apiAccessBlacklist`, params),

  // 删除接口请求屏蔽
  delAccessBlack: (id) => axios.delete(`/api/1/apiAccessBlacklist/${id}`),

  // 更新接口请求屏蔽
  updateAccessBlack: (id, params) =>
    axios.put(`/api/1/apiAccessBlacklist/${id}`, params),

  // 添加测试组
  addMacGroups: (params) => axios.post(`/api/1/macGroups`, params),

  // 删除测试组
  delMacGroups: (id) => axios.delete(`/api/1/macGroups/${id}`),

  // 更新测试组
  updateMacGroups: (id, params) => axios.put(`/api/1/macGroups/${id}`, params),

  // 获取测试组列表
  getMacGroups: (params) => axios.get(`/api/1/macGroups`, { params }),

  // 获取测试组详情
  getMacGroupsDetails: (id) => axios.get(`/api/1/macGroups/${id}`),

  // 同步服务器数据
  syncCnData: (params) => axios.post(`/api/1/serverInfos/sync/cn/data`, params),

  // 获取gpt条件列表
  gptGptConditionList: (params) =>
    axios.get(`/api/1/admin/ai/condition/list`, { params }),

  // 删除gpt条件
  delGptCondition: (params) =>
    axios.delete(`/api/1/admin/ai/condition/batch`, { data: params }),

  // 创建gpt条件
  addGptCondition: (params) => axios.post(`/api/1/admin/ai/condition`, params),

  // 更新gpt条件
  updateGptCondition: (id, params) =>
    axios.put(`/api/1/admin/ai/condition/${id}`, params),

  // 获取gpt提示语列表
  getGptPromptList: (params) =>
    axios.get(`/api/1/admin/ai/prompt/list`, { params }),

  // 获取gpt提示语详情
  getGptPromptDetails: (id) => axios.get(`/api/1/admin/ai/prompt/detail/${id}`),

  // 创建gpt提示语
  addGptPrompt: (params) => axios.post(`/api/1/admin/ai/prompt`, params),

  // 更新gpt提示语
  updateGptPrompt: (id, params) =>
    axios.put(`/api/1/admin/ai/prompt/${id}`, params),

  // 删除gpt提示语
  delGptPrompt: (params) =>
    axios.delete(`/api/1/admin/ai/prompt/batch`, { data: params }),

  // 获取国家列表
  getCountryList: (params) => axios.get(`/api/1/country/list`, { params }),

  // 获取gpt引擎列表
  getGptEngineList: (params) =>
    axios.get(`/api/1/admin/ai/engine/list`, { params }),

  // 获取管理数据类型列表
  getAdminConfigDataTypeList: (params) =>
    axios.get(`/api/1/admin/config/data/type/list`, { params }),

  // 获取管理配置类型列表
  getAdminConfigTypeList: (params) =>
    axios.get(`/api/1/admin/config/type/list`, { params }),

  // 获取管理配置列表
  getAdminConfigList: (params) =>
    axios.get(`/api/1/admin/config/list`, { params }),

  // 创建管理配置
  createAdminConfig: (params) => axios.post(`/api/1/admin/config`, params),

  // 更新管理配置
  updateAdminConfig: (id, params) =>
    axios.put(`/api/1/admin/config/${id}`, params),

  // 删除管理配置
  delAdminConfig: (params) =>
    axios.delete(`/api/1/admin/config/batch`, { data: params }),

  // 获取管理配置详情
  getAdminConfigDetails: (id) => axios.get(`/api/1/admin/config/${id}/detail`),

  // 获取内部设备列表
  getInternalDeviceList: (params) =>
    axios.get(`/api/1/admin/internalDevice`, { params }),

  // 获取内部设备绑定记录
  getInternalDeviceRecord: (id, params) =>
    axios.get(`/api/1/admin/internalDevice/${id}/record`, { params }),

  // 解绑内部设备
  unbindInternalDevice: (id) =>
    axios.post(`/api/1/admin/internalDevice/${id}/unbind`),

  // 编辑绑定设备时间
  editInternalDevice: (id, params) =>
    axios.put(`/api/1/admin/internalDevice/${id}/boundTime`, params),

  // ==================== starNote学院相关接口 ====================
  // 通用配置 - 标签管理
  // 获取标签列表
  getMaterialTagList: (params) =>
    axios.get(`/api/v2/admin/boox/res/tag`, { params }),

  // 获取标签详情
  getMaterialTagDetails: (id) =>
    axios.get(`/api/v2/admin/boox/res/tag/${id}`),

  // 创建标签
  addMaterialTag: (params) =>
    axios.post(`/api/v2/admin/boox/res/tag`, params),

  // 更新标签
  updateMaterialTag: (id, params) =>
    axios.put(`/api/v2/admin/boox/res/tag/${id}`, params),

  // 删除标签
  delMaterialTag: (id) =>
    axios.delete(`/api/v2/admin/boox/res/tag/${id}`),

  // 获取标签操作详情
  getMaterialTagOptRecord: (id, params) =>
    axios.get(`/api/v2/admin/boox/res/tag/${id}/optRecord`, { params }),

  // 通用配置 - 发布人管理
  // 发布地区列表
  getMaterialPublisherArea: (params) =>
    axios.get(`/api/v2/admin/boox/collegeAvailableAreas`, { params }),

  // 发布人列表
  getMaterialPublisherList: (params) =>
    axios.get(`/api/v2/admin/boox/res/publisher`, { params }),

  // 发布人详情
  getMaterialPublisherDetails: (id) =>
    axios.get(`/api/v2/admin/boox/res/publisher/${id}`),

  // 创建发布人
  addMaterialPublisher: (params) =>
    axios.post(`/api/v2/admin/boox/res/publisher`, params),

  // 更新发布人
  updateMaterialPublisher: (id, params) =>
    axios.put(`/api/v2/admin/boox/res/publisher/${id}`, params),

  // 删除发布人
  delMaterialPublisher: (id) =>
    axios.delete(`/api/v2/admin/boox/res/publisher/${id}`),

  // 获取发布人操作详情
  getMaterialPublisherOptRecord: (id, params) =>
    axios.get(`/api/v2/admin/boox/res/publisher/${id}/optRecord`, { params }),

  // 资料库管理==================
  // 资料库列表
  getMaterialList: (params) =>
    axios.get(`/api/v2/admin/material`, { params }),

  // 资料库详情
  getMaterialDetails: (id) =>
    axios.get(`/api/v2/admin/material/${id}`),

  // 创建资料库
  addMaterial: (params) =>
    axios.post(`/api/v2/admin/material`, params),

  // 复制资料库
  copyMaterial: (id) =>
    axios.post(`/api/v2/admin/material/${id}/duplicate`),

  // 更新资料库
  updateMaterial: (id, params) =>
    axios.put(`/api/v2/admin/material/${id}`, params),

  // 更新资料库状态
  updateMaterialStatus: (id, params) =>
    axios.put(`/api/v2/admin/material/${id}/status`, params),

  // 删除资料库
  delMaterial: (id) =>
    axios.delete(`/api/v2/admin/material/${id}`),

  // 获取资料库操作详情
  getMaterialOptRecord: (id, params) =>
    axios.get(`/api/v2/admin/material/${id}/optRecord`, { params }),

  // 资料库测试
  testMaterial: (id, params) =>
    axios.put(`/api/v2/admin/material/${id}/testCondition`, params),

  // 资料库分类管理
  // 获取分类树
  getMaterialCategoryTree: (params) =>
    axios.get(`/api/v2/admin/material/category`, { params }),

  // 获取分类详情
  getMaterialCategoryDetails: (id) =>
    axios.get(`/api/v2/admin/material/category/${id}`),

  // 创建分类
  addMaterialCategory: (params) =>
    axios.post(`/api/v2/admin/material/category`, params),

  // 更新分类
  updateMaterialCategory: (id, params) =>
    axios.put(`/api/v2/admin/material/category/${id}`, params),

  // 更改分类排序
  updateMaterialCategoryOrdinal: (id, params) =>
    axios.put(`/api/v2/admin/material/category/${id}/ordinal`, params),

  // 删除分类
  delMaterialCategory: (id) =>
    axios.delete(`/api/v2/admin/material/category/${id}`),

  // 将资料加入分类
  addDataToMaterialCategory: (id, params) =>
    axios.post(`/api/v2/admin/material/category/${id}/addMaterial`, params),

  // 将资料移出分类
  delDataFromMaterialCategory: (id, params) =>
    axios.post(`/api/v2/admin/material/category/${id}/removeMaterial`, params),

  // 更改分类下资料排序
  updateMaterialOrdinalInCategory: (id, materialId, params) =>
    axios.put(
      `/api/v2/admin/material/category/${id}/material/${materialId}/ordinal`,
      params
    ),

  // 模版库管理==================
  // 模版库列表
  getTemplateList: (params) =>
    axios.get(`/api/v2/admin/boox/template`, { params }),

  // 模版库详情
  getTemplateDetails: (id) =>
    axios.get(`/api/v2/admin/boox/template/${id}`),

  // 创建模版库
  addTemplate: (params) =>
    axios.post(`/api/v2/admin/boox/template`, params),

  // 复制模版库
  copyTemplate: (id) =>
    axios.post(`/api/v2/admin/boox/template/${id}/duplicate`),

  // 更新模版库
  updateTemplate: (id, params) =>
    axios.put(`/api/v2/admin/boox/template/${id}`, params),

  // 更新模版库状态
  updateTemplateStatus: (id, params) =>
    axios.put(`/api/v2/admin/boox/template/${id}/status`, params),

  // 删除模版库
  delTemplate: (id) =>
    axios.delete(`/api/v2/admin/boox/template/${id}`),

  // 获取模版库操作详情
  getTemplateOptRecord: (id, params) =>
    axios.get(`/api/v2/admin/boox/template/${id}/optRecord`, { params }),

  // 模版库测试
  testTemplate: (id, params) =>
    axios.put(`/api/v2/admin/boox/template/${id}/testCondition`, params),

  // 模版库分类管理==================
  // 获取分类树
  getTemplateCategoryTree: (params) =>
    axios.get(`/api/v2/admin/boox/template/category`, { params }),

  // 获取分类详情
  getTemplateCategoryDetails: (id) =>
    axios.get(`/api/v2/admin/boox/template/category/${id}`),

  // 创建分类
  addTemplateCategory: (params) =>
    axios.post(`/api/v2/admin/boox/template/category`, params),

  // 更新分类
  updateTemplateCategory: (id, params) =>
    axios.put(`/api/v2/admin/boox/template/category/${id}`, params),

  // 更改分类排序
  updateTemplateCategoryOrdinal: (id, params) =>
    axios.put(`/api/v2/admin/boox/template/category/${id}/ordinal`, params),

  // 删除分类
  delTemplateCategory: (id) =>
    axios.delete(`/api/v2/admin/boox/template/category/${id}`),

  // 将模版加入分类
  addDataToTemplateCategory: (id, params) =>
    axios.post(`/api/v2/admin/boox/template/category/${id}/addItem`, params),

  // 将模版移出分类
  delDataFromTemplateCategory: (id, params) =>
    axios.post(`/api/v2/admin/boox/template/category/${id}/removeItem`, params),

  // 更改分类下模版排序
  updateTemplateOrdinalInCategory: (id, templateId, params) =>
    axios.put(
      `/api/v2/admin/boox/template/category/${id}/template/${templateId}/ordinal`,
      params
    ),

  // 贴纸库管理==================
  // 贴纸库列表
  getStickerList: (params) =>
    axios.get(`/api/v2/admin/boox/sticker`, { params }),

  // 贴纸库详情
  getStickerDetails: (id) =>
    axios.get(`/api/v2/admin/boox/sticker/${id}`),

  // 创建贴纸库
  addSticker: (params) =>
    axios.post(`/api/v2/admin/boox/sticker`, params),

  // 复制贴纸库
  copySticker: (id) =>
    axios.post(`/api/v2/admin/boox/sticker/${id}/duplicate`),

  // 更新贴纸库
  updateSticker: (id, params) =>
    axios.put(`/api/v2/admin/boox/sticker/${id}`, params),

  // 更新贴纸库状态
  updateStickerStatus: (id, params) =>
    axios.put(`/api/v2/admin/boox/sticker/${id}/status`, params),

  // 删除贴纸库
  delSticker: (id) =>
    axios.delete(`/api/v2/admin/boox/sticker/${id}`),

  // 获取贴纸库操作详情
  getStickerOptRecord: (id, params) =>
    axios.get(`/api/v2/admin/boox/sticker/${id}/optRecord`, { params }),

  // 贴纸库测试
  testSticker: (id, params) =>
    axios.put(`/api/v2/admin/boox/sticker/${id}/testCondition`, params),

  // 贴纸库分类管理
  // 获取分类树
  getStickerCategoryTree: (params) =>
    axios.get(`/api/v2/admin/boox/sticker/category`, { params }),

  // 获取分类详情
  getStickerCategoryDetails: (id) =>
    axios.get(`/api/v2/admin/boox/sticker/category/${id}`),

  // 创建分类
  addStickerCategory: (params) =>
    axios.post(`/api/v2/admin/boox/sticker/category`, params),

  // 更新分类
  updateStickerCategory: (id, params) =>
    axios.put(`/api/v2/admin/boox/sticker/category/${id}`, params),

  // 更改分类排序
  updateStickerCategoryOrdinal: (id, params) =>
    axios.put(`/api/v2/admin/boox/sticker/category/${id}/ordinal`, params),

  // 删除分类
  delStickerCategory: (id) =>
    axios.delete(`/api/v2/admin/boox/sticker/category/${id}`),

  // 将贴纸加入分类
  addDataToStickerCategory: (id, params) =>
    axios.post(`/api/v2/admin/boox/sticker/category/${id}/addItem`, params),

  // 将贴纸移出分类
  delDataFromStickerCategory: (id, params) =>
    axios.post(`/api/v2/admin/boox/sticker/category/${id}/removeItem`, params),

  // 更改分类下贴纸排序
  updateStickerOrdinalInCategory: (id, stickerId, params) =>
    axios.put(
      `/api/v2/admin/boox/sticker/category/${id}/sticker/${stickerId}/ordinal`,
      params
    ),

  // 首页配置 - 布局配置
  // 获取当前的布局配置
  getCurrentLayoutConfig: (params) =>
    axios.get(`/api/v2/admin/boox/resource/layout/current`, {
      params,
      headers: { "client-type": "boox" }
    }),

  // 获取布局对应的模块列表
  getLayoutModuleList: (id, params) =>
    axios.get(`/api/v2/admin/boox/resource/layout/${id}/module`, {
      params,
      headers: { "client-type": "boox" }
    }),

  // 更新布局配置状态
  updateLayoutConfigStatus: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/layout/${id}/status`, params, {
      headers: { "client-type": "boox" }
    }),

  // 测试布局配置
  testLayoutConfig: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/layout/${id}/testCondition`, params, {
      headers: { "client-type": "boox" }
    }),

  // 将模块移入布局
  addLayoutModule: (id, params) =>
    axios.post(`/api/v2/admin/boox/resource/layout/${id}/addItem`, params, {
      headers: { "client-type": "boox" }
    }),

  // 将模块移出布局
  removeLayoutModule: (id, params) =>
    axios.post(`/api/v2/admin/boox/resource/layout/${id}/removeItem`, params, {
      headers: { "client-type": "boox" }
    }),

  // 更改模块排序
  updateLayoutModuleOrdinal: (shipId, params) =>
    axios.put(`/api/v2/admin/boox/resource/layout/ship/${shipId}/ordinal`, params, {
      headers: { "client-type": "boox" }
    }),

  // 测试模块
  testLayoutModule: (shipId, params) =>
    axios.put(
      `/api/v2/admin/boox/resource/layout/ship/${shipId}/testCondition`,
      params,
      { headers: { "client-type": "boox" } }
    ),

  // 获取布局配置操作详情
  getLayoutConfigOptRecord: (shipId, params) =>
    axios.get(
      `/api/v2/admin/boox/resource/layout/ship/${shipId}/optRecord`,
      { params }
    ),

  // 首页配置模块
  // 首页配置模块列表
  getIndexConfigModulesList: (params) =>
    axios.get(`/api/v2/admin/boox/resource/module`, {
      params,
      headers: { "client-type": "boox" }
    }),

  // 首页配置模块详情
  getIndexConfigModulesDetails: (id) =>
    axios.get(`/api/v2/admin/boox/resource/module/${id}`, {
      headers: { "client-type": "boox" }
    }),

  // 创建首页配置模块
  addIndexConfigModules: (params) =>
    axios.post(`/api/v2/admin/boox/resource/module`, params, {
      headers: { "client-type": "boox" }
    }),

  // 更新首页配置模块
  updateIndexConfigModules: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/module/${id}`, params, {
      headers: { "client-type": "boox" }
    }),

  // 删除首页配置模块
  delIndexConfigModules: (id) =>
    axios.delete(`/api/v2/admin/boox/resource/module/${id}`, {
      headers: { "client-type": "boox" }
    }),

  // 获取首页配置模块资源列表
  getIndexConfigModulesResourceList: (id, params) =>
    axios.get(`/api/v2/admin/boox/resource/module/${id}/resource`, {
      params,
      headers: { "client-type": "boox" }
    }),

  // 将资源移入首页配置模块
  addIndexConfigModulesResource: (id, params) =>
    axios.post(`/api/v2/admin/boox/resource/module/${id}/addItem`, params, {
      headers: { "client-type": "boox" }
    }),

  // 将资源移出首页配置模块
  removeIndexConfigModulesResource: (id, params) =>
    axios.post(`/api/v2/admin/boox/resource/module/${id}/removeItem`, params, {
      headers: { "client-type": "boox" }
    }),

  // 更改首页配置模块资源排序
  updateIndexConfigModulesResourceOrdinal: (shipId, params) =>
    axios.put(
      `/api/v2/admin/boox/resource/module/ship/${shipId}/ordinal`,
      params,
      { headers: { "client-type": "boox" } }
    ),

  // 获取首页配置模块操作详情
  getIndexConfigModulesOptRecord: (shipId, params) =>
    axios.get(
      `/api/v2/admin/boox/resource/module/ship/${shipId}/optRecord`,
      { params }
    ),

  // 卡片素材库
  // 卡片素材详情
  getCardMaterialDetails: (id) =>
    axios.get(`/api/v2/admin/boox/resource/collection/${id}`),

  // 创建卡片素材
  addCardMaterial: (params) =>
    axios.post(`/api/v2/admin/boox/resource/collection`, params),

  // 更新卡片素材
  updateCardMaterial: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/collection/${id}`, params),

  // 更新卡片素材状态
  updateCardMaterialStatus: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/collection/${id}/status`, params),

  // 删除卡片素材
  delCardMaterial: (id) =>
    axios.delete(`/api/v2/admin/boox/resource/collection/${id}`),

  // 卡片素材测试
  testCardMaterial: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/collection/${id}/testCondition`, params),

  // Banner素材库
  // banner素材详情
  getBannerMaterialDetails: (id) =>
    axios.get(`/api/v2/admin/boox/resource/banner/${id}`),

  // 创建banner素材
  addBannerMaterial: (params) => {
    // 确保 resourceType 存在（galaxy 中素材中心为 RESOURCE，数据中心为 MATERIAL）
    const data = { ...params };
    if (!data.resourceType) {
      data.resourceType = "RESOURCE";
    }
    return axios.post(`/api/v2/admin/boox/resource/banner`, data);
  },

  // 更新banner素材
  updateBannerMaterial: (id, params) => {
    // 确保 resourceType 存在
    const data = { ...params };
    if (!data.resourceType) {
      data.resourceType = "RESOURCE";
    }
    return axios.put(`/api/v2/admin/boox/resource/banner/${id}`, data);
  },

  // 更新banner素材状态
  updateBannerMaterialStatus: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/banner/${id}/status`, params, {
      headers: { "client-type": "boox" }
    }),

  // 删除banner素材
  delBannerMaterial: (id) =>
    axios.delete(`/api/v2/admin/boox/resource/banner/${id}`, {
      headers: { "client-type": "boox" }
    }),

  // banner素材测试
  testBannerMaterial: (id, params) =>
    axios.put(`/api/v2/admin/boox/resource/banner/${id}/testCondition`, params, {
      headers: { "client-type": "boox" }
    }),


  // 学院型号组管理
  // 获取学院型号组列表
  getCollegeModelGroups: (params) =>
    axios.get(`/api/v2/admin/boox/modelGroups`, {
      params,
    }),

  // 获取学院型号组详情
  getCollegeModelGroupDetail: (id) =>
    axios.get(`/api/v2/admin/boox/modelGroups/${id}`),

  // 创建学院型号组
  createCollegeModelGroups: (params) =>
    axios.post(`/api/v2/admin/boox/modelGroups`, params),

  // 编辑学院型号组
  updateCollegeModelGroup: (id, params) =>
    axios.put(`/api/v2/admin/boox/modelGroups/${id}`, params),

  // 删除学院型号组
  delCollegeModelGroup: (id) => axios.delete(`/api/v2/admin/boox/modelGroups/${id}`),

  // 运营口令
  // 运营口令列表
  getShareCodeList: (params) =>
    axios.post(`/api/v2/admin/resource/shareCode/query`, params),

  // 预生成运营口令
  preGenerateShareCode: () =>
    axios.post(`/api/v2/admin/resource/shareCode/preGenerate`),

  // 创建运营口令
  addShareCode: (params) =>
    axios.post(`/api/v2/admin/resource/shareCode`, params),

  // 更新运营口令
  updateShareCode: (id, params) =>
    axios.put(`/api/v2/admin/resource/shareCode/${id}`, params),

  // 作废运营口令
  invalidateShareCode: (id) =>
    axios.post(`/api/v2/admin/resource/shareCode/${id}/invalidate`),

  // 获取运营口令操作详情
  getShareCodeOptRecord: (id, params) =>
    axios.get(`/api/v2/admin/resource/shareCode/${id}/optRecord`, { params }),

  // 文案管理
  // 文案列表
  getPhraseList: (params) =>
    axios.get(`/api/v2/admin/resource/shareCode/phrase`, { params }),

  // 创建文案
  addPhrase: (params) =>
    axios.post(`/api/v2/admin/resource/shareCode/phrase`, params),

  // 更新文案
  updatePhrase: (id, params) =>
    axios.put(`/api/v2/admin/resource/shareCode/phrase/${id}`, params),

  // 删除文案
  deletePhrase: (id) =>
    axios.delete(`/api/v2/admin/resource/shareCode/phrase/${id}`),

  // 短信白名单管理
  // 获取短信白名单列表
  getSmsWhitelist: (params) =>
    axios.get(`/api/v2/admin/sms/whitelist`, {
      params: params,
    }),

  // 获取短信白名单详情
  getSmsWhitelistDetail: (id) =>
    axios.get(`/api/v2/admin/sms/whitelist/${id}`),

  // 创建短信白名单
  createSmsWhitelist: (params) =>
    axios.post(`/api/v2/admin/sms/whitelist`, params),

  // 更新短信白名单
  updateSmsWhitelist: (id, params) =>
    axios.put(`/api/v2/admin/sms/whitelist/${id}`, params),

  // 删除短信白名单
  deleteSmsWhitelist: (id) =>
    axios.delete(`/api/v2/admin/sms/whitelist/${id}`),

  // AppConf 应用优化配置管理
  // 获取应用配置列表（管理员）
  getAppConfList: (params) =>
    axios.get(`/api/v2/internal/appConf`, {
      params: params,
    }),

  // 获取应用配置详情（管理员）
  getAppConfDetail: (id) => axios.get(`/api/v2/internal/appConf/${id}`),

  // 创建应用配置（管理员）
  createAppConf: (params) => axios.post(`/api/v2/internal/appConf`, params),

  // 更新应用配置（管理员）
  updateAppConf: (id, params) =>
    axios.put(`/api/v2/internal/appConf/${id}`, params),

  // 删除应用配置（管理员）
  deleteAppConf: (id) => axios.delete(`/api/v2/internal/appConf/${id}`),

  // 设置为推荐
  recommendAppConf: (id, params) =>
    axios.post(`/api/v2/internal/appConf/${id}/recommend`, params),

  // 取消推荐
  unrecommendAppConf: (id) =>
    axios.delete(`/api/v2/internal/appConf/${id}/recommend`),

  // 切换配置状态（启用/禁用）
  toggleAppConfStatus: (id, params) =>
    axios.put(`/api/v2/internal/appConf/${id}/status`, params),

  // AppConfTag 应用配置标签管理
  // 获取标签列表
  getAppConfTagList: (params) =>
    axios.get(`/api/v2/appConfTag`, {
      params: params,
    }),

  // 获取标签详情
  getAppConfTagDetail: (id) => axios.get(`/api/v2/appConfTag/${id}`),

  // 创建标签（管理员）
  createAppConfTag: (params) =>
    axios.post(`/api/v2/internal/appConfTag`, params),

  // 更新标签（管理员）
  updateAppConfTag: (id, params) =>
    axios.put(`/api/v2/internal/appConfTag/${id}`, params),

  // 删除标签（管理员）
  deleteAppConfTag: (id) => axios.delete(`/api/v2/internal/appConfTag/${id}`),

  // 切换标签状态（管理员）
  toggleAppConfTagStatus: (id, params) =>
    axios.put(`/api/v2/internal/appConfTag/${id}/status`, params),

  // 批量更新标签排序（管理员）
  batchUpdateAppConfTagSort: (params) =>
    axios.post(`/api/v2/internal/appConfTag/batch/sort`, params),

  // 获取所有标签列表（管理员，包含禁用）
  getAppConfTagListAdmin: (params) =>
    axios.get(`/api/v2/internal/appConfTag`, {
      params: params,
    }),

  // GodCode 大神码管理
  // 获取大神码列表（管理员）
  getGodCodeList: (params) =>
    axios.get(`/api/v2/internal/godCode`, {
      params: params,
    }),

  // 获取大神码详情（管理员）
  getGodCodeDetail: (id) => axios.get(`/api/v2/internal/godCode/${id}`),

  // 更新大神码（管理员）
  updateGodCode: (id, params) =>
    axios.put(`/api/v2/internal/godCode/${id}`, params),

  // 删除大神码（管理员）
  deleteGodCode: (id) => axios.delete(`/api/v2/internal/godCode/${id}`),

  // 推荐大神码
  recommendGodCode: (id, params) =>
    axios.post(`/api/v2/internal/godCode/${id}/recommend`, params),

  // 取消推荐大神码
  unrecommendGodCode: (id) =>
    axios.delete(`/api/v2/internal/godCode/${id}/recommend`),

  // 切换大神码状态（启用/禁用）
  toggleGodCodeStatus: (id, params) =>
    axios.put(`/api/v2/internal/godCode/${id}/status`, params),

  // 获取大神码统计信息（管理员）
  getGodCodeStatistics: () =>
    axios.get(`/api/v2/internal/godCode/statistics`),

  // 查找相同配置的大神码（管理员）
  findSameGodCode: (id) =>
    axios.get(`/api/v2/internal/godCode/${id}/same`),

  // AppConfGroup 应用配置分组管理
  // 获取配置分组列表（管理员）
  getAppConfGroupList: (params) =>
    axios.get(`/api/v2/internal/appConfGroup`, {
      params: params,
    }),

  // 获取配置分组详情（管理员）
  getAppConfGroupDetail: (id) => axios.get(`/api/v2/internal/appConfGroup/${id}`),

  // 创建配置分组（管理员）
  createAppConfGroup: (params) =>
    axios.post(`/api/v2/internal/appConfGroup`, params),

  // 更新配置分组（管理员）
  updateAppConfGroup: (id, params) =>
    axios.put(`/api/v2/internal/appConfGroup/${id}`, params),

  // 删除配置分组（管理员）
  deleteAppConfGroup: (id) =>
    axios.delete(`/api/v2/internal/appConfGroup/${id}`),

  // 切换分组状态（管理员）
  toggleAppConfGroupStatus: (id, params) =>
    axios.put(`/api/v2/internal/appConfGroup/${id}/status`, params),

  // 给分组添加型号（管理员）
  addModelsToGroup: (id, params) =>
    axios.post(`/api/v2/internal/appConfGroup/${id}/models`, params),

  // 从分组移除型号（管理员）
  removeModelsFromGroup: (id, params) =>
    axios.delete(`/api/v2/internal/appConfGroup/${id}/models`, {
      data: params,
    }),

  // 根据型号查询分组（管理员）
  findGroupByModel: (params) =>
    axios.get(`/api/v2/internal/appConfGroup/findByModel`, {
      params: params,
    }),
};
